import { sample } from "underscore";

const finished = state => !(state.current == state.total);
const random = state => sample(state.list, 4);
const loaded = state => state.loaded;

export default {
  finished,
  random,
  loaded
};
